import { ResultOf } from 'gql.tada';
import { gql } from '../../gql';

export const GET_PLATFORM_PLAN_IDS = gql(`
  query GetPlatformPlanIds(
    $where: JSON
    $groupBy: [String]
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    platformPlans(
      where: $where
      groupBy: $groupBy
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
    }
  }
`);

export const GET_PLATFORM_PLANS = gql(`
  query GetPlatformPlans($where: JSON) {
    platformPlans(where: $where) {
      id
      name
      description
      products {
        __typename
        id
        type
        price
        billingFrequency
        billingTiming
        billTo
      }
    }
  }
`);

export type PlatformPlan = ResultOf<
  typeof GET_PLATFORM_PLANS
>['platformPlans'][number];

export type PlatformProduct = PlatformPlan['products'][number];
export type PlatformProductInput = OptionalProps<
  PlatformProduct,
  'id' | '__typename'
>;

export type ProductTypeAll = PlatformProduct['type'];
export type ProductType = Exclude<PlatformProduct['type'], 'SUBSCRIPTION'>;

export const productTypeLabels: Record<ProductType, string> = {
  BACKFLOW_ACTIVE_ASSEMBLY: 'Active Assembly',
  BACKFLOW_TEST_PASSED: 'Test Report - Passing',
  BACKFLOW_TEST: 'Test Report',
  BACKFLOW_NOTICE_CREATED: 'Notice Created',
  BACKFLOW_NOTICE_MAILED: 'Notice Mailed',
  // SUBSCRIPTION: 'Subscription',
};
